const historicalArchiveColumns = {
  acceptanceDate: {
    key: 'acceptanceDate',
    label: 'acceptanceDate',
    type: 'date',
    sortable: true,
    minWidth: '120px',
  },
  reportCode: {
    key: 'reportCode',
    label: 'reportCode',
    type: 'text',
    sortable: true,
    minWidth: '120px',
  },
  productCode: {
    key: 'productCode',
    label: 'productCode',
    type: 'text',
    sortable: true,
    minWidth: '120px',
  },
  productName: {
    key: 'productName',
    label: 'productName',
    type: 'text',
    sortable: true,
    minWidth: '130px',
  },
  sampleDescription: {
    key: 'sampleDescription',
    label: 'sampleDescription',
    type: 'text',
    sortable: true,
    minWidth: '130px',
  },
  customerSampleCode: {
    key: 'customerSampleCode',
    label: 'customerSampleCode',
    type: 'text',
    sortable: true,
    minWidth: '120px',
  },
  lot: {
    key: 'lot',
    label: 'lot',
    type: 'text',
    sortable: true,
    minWidth: '100px',
  },
  lotDate: {
    key: 'lotDate',
    label: 'lotDate',
    // Free text on the backend view (VARCHAR), not a date: do not parse it
    type: 'text',
    sortable: true,
    minWidth: '110px',
  },
  department: {
    key: 'department',
    label: 'department',
    type: 'text',
    sortable: true,
    minWidth: '110px',
  },
  reportIssueDate: {
    key: 'reportIssueDate',
    label: 'reportIssueDate',
    type: 'date',
    sortable: true,
    minWidth: '120px',
  },
  alreadyDownloaded: {
    key: 'alreadyDownloaded',
    label: 'alreadyDownloaded',
    type: 'function',
    enum: 'commons',
    sortable: true,
    align: 'center',
    minWidth: '110px',
    get: value => (value ? 'yes' : 'no'),
  },
  firstDownloadDate: {
    key: 'firstDownloadDate',
    label: 'firstDownloadDate',
    type: 'date',
    sortable: true,
    minWidth: '120px',
  },
  actions: {
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: 'right',
    minWidth: '100px',
    align: 'center',
    buttons: [
      {
        name: 'downloadReport',
        icon: 'fas fa-download',
        color: 'green',
        // No archived PDF (pdfFileId null) means the download would answer 404
        showCondition: row => !!row.pdfFileId,
      },
    ],
  },
};

export default historicalArchiveColumns;
